
import UserInfo from '@/mobileComponents/UserInfo'
import ApiHeader from '@/mobileComponents/openapi/ApiHeader'
import MonitorList from '@/mobileComponents/openapi/MonitorList'

export default {
  name: 'OpenApi',
  data() {
    return {
      // 功能api列表
      settingList: [],
      showLoading: true,
      isActive: 0,
    }
  },
  components: {
    UserInfo,
    ApiHeader,
    MonitorList,
  },
  created() {
    this.getApi()
    if (this.$route.query.apiActive) {
      this.isActive = this.$route.query.apiActive
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push('/mobile')
    },
    // 获取功能api列表
    async getApi() {
      try {
        const { data } = await this.$http.post('/apiinterface/apilist')
        if (data.status === 'success') {
          this.settingList = data.data
          this.showLoading = false
        } else {
          this.$notify({
            type: 'danger',
            message: data.msg
          })
          this.showLoading = false
        }
      } catch (err) {
        this.$notify({
          type: 'danger',
          message: '网络异常,请稍后重试'
        })
      }
    },
  },
}
